import { PricingRuleSet } from "@redotech/redo-model/team";
import { isDefined } from "@redotech/util/type";
import { CoverageCalculator, CoverageType } from ".";
import { packageProtectionCoverageCalculator } from "./package-protection";
import { returnCoverageCalculator } from "./returns";

export function determineRuleSet(
  pricingRuleSets: PricingRuleSet[],
  country: string | null,
) {
  for (const priceSet of pricingRuleSets) {
    if (
      !isDefined(country) ||
      priceSet.countries.some(
        (c) => c.toLowerCase() === country.toLowerCase(),
      ) ||
      priceSet.countries.length == 0
    ) {
      return priceSet;
    }
  }
  return null;
}

export function getApplicableRule(ruleSet: PricingRuleSet, cartTotal: number) {
  if (!cartTotal) {
    return ruleSet.priceBrackets[0];
  }
  for (let i = 0; i < ruleSet.priceBrackets.length; i++) {
    if (i === ruleSet.priceBrackets.length - 1) {
      return ruleSet.priceBrackets[i];
    }

    if (
      cartTotal > ruleSet.priceBrackets[i].pricePoint &&
      cartTotal <= ruleSet.priceBrackets[i + 1].pricePoint
    ) {
      return ruleSet.priceBrackets[i];
    }
  }
  return ruleSet.priceBrackets[ruleSet.priceBrackets.length - 1];
}

export function getProductCalculator(type: CoverageType) {
  let productCalculator: CoverageCalculator;
  switch (type) {
    case "Returns":
      productCalculator = returnCoverageCalculator;
      break;
    case "Package Protection":
      productCalculator = packageProtectionCoverageCalculator;
      break;
    default:
      productCalculator = returnCoverageCalculator;
      break;
  }
  return productCalculator;
}

export function listsHaveMatchingElement(list1: string[], list2: string[]) {
  return list1.some((key) =>
    list2.some((attribute) => attribute.toLowerCase() === key.toLowerCase()),
  );
}

export function getPricingRulesInLocalCurrency(
  pricingRuleSets: PricingRuleSet[],
  exchangeRate: number,
) {
  return pricingRuleSets.map((ruleSet) => {
    ruleSet.priceBrackets.map((bracket) => {
      if (ruleSet.type === "fixed") {
        bracket.value = bracket.value * exchangeRate;
      }
      bracket.pricePoint = bracket.pricePoint * exchangeRate;
      return bracket;
    });

    return ruleSet;
  });
}
